import UPNG from "@pdf-lib/upng";
import { encode as encode64 } from "base64-arraybuffer";
import { decode as decodeBlurHash, isBlurhashValid } from "blurhash";
import { DEFAULT_BLUR_HASH } from "../constants";
const filterValidProps = (object) => {
  if (object?.backgroundColor) {
    const backgroundColor = object.backgroundColor.toLowerCase();
    if (!backgroundColor.startsWith("var(") || backgroundColor.startsWith("#") || backgroundColor.startsWith("rgba")) {
      delete object.backgroundColor;
    }
  }
  for (const key in object) {
    const lowerCaseKey = key.toLowerCase();
    if (lowerCaseKey.startsWith("font") || lowerCaseKey === "color") {
      delete object[key];
    }
  }
  return object;
};
const wrapImage = (s) => `data:image/png;base64,${s}`;
const blurHashToBase64 = (blurHash, aspectRatio, width, height) => {
  const bh = isBlurhashValid(blurHash).result ? blurHash : DEFAULT_BLUR_HASH;
  const w = (aspectRatio ?? 1) * width;
  const pixels = decodeBlurHash(bh, w, height);
  const encodePng = UPNG?.encode ?? UPNG?.default?.encode;
  const png = encodePng([pixels], w, height, 256);
  return wrapImage(encode64(png));
};
const NATIVE_COLOR_VALUES_REGEXP = /^(inherit|currentcolor|initial|unset|var\()/ui;
const HEX_COLOR_REGEXP = /^#([a-zA-Z0-9]{3,8})/ui;
const isSystemColorValue = (color) => NATIVE_COLOR_VALUES_REGEXP.test(color);
const isHexColor = (color) => HEX_COLOR_REGEXP.test(color);
function notReachable(_) {
  throw new Error(`Should never be reached ${_}`);
}
export * from "./nonEmptyItem";
export * from "./sortJSON";
export {
  blurHashToBase64,
  filterValidProps,
  isHexColor,
  isSystemColorValue,
  notReachable
};
